import React from "react";
import Index from "./pages/Index";

function App() {
  return <Index />;
}

export default App;
